import { FC } from 'react';
import { Button, IconButton, Tooltip } from '@chakra-ui/react';
import { BiCloudDownload } from 'react-icons/bi';

import {
  FileBrowserFileFragment,
  FileDetailsFileFragment,
} from '../../graphql/generated';
import { DownloadDisabledTooltip } from '../download-disabled-tooltip/download-disabled-tooltip';

type Props = {
  onDownload: () => Promise<void>;
};

export const FileDownloadButton: FC<
  Props & { file: FileDetailsFileFragment }
> = ({ file, onDownload }) => {
  if (!file.canDownload) {
    return (
      <DownloadDisabledTooltip file={file}>
        <Button
          disabled
          size="lg"
          data-testid="file-download-button"
          leftIcon={<BiCloudDownload size="22" />}
        >
          Download
        </Button>
      </DownloadDisabledTooltip>
    );
  }

  return (
    <Button
      size="lg"
      onClick={onDownload}
      data-testid="file-download-button"
      leftIcon={<BiCloudDownload size="22" />}
    >
      Download
    </Button>
  );
};

export const FileDownloadIconButton: FC<
  Props & { file: FileBrowserFileFragment }
> = ({ file, onDownload }) => {
  if (!file.canDownload) {
    return (
      <DownloadDisabledTooltip file={file}>
        <IconButton
          disabled
          size="lg"
          variant="clear"
          aria-label="file download button"
          data-testid="file-download-button"
          icon={<BiCloudDownload size="22" />}
        />
      </DownloadDisabledTooltip>
    );
  }

  return (
    <Tooltip label="Download" fontSize="xs">
      <IconButton
        size="lg"
        variant="clear"
        onClick={onDownload}
        data-testid="file-download-button"
        _focus={{ boxShadow: 'none' }}
        aria-label="file download button"
        icon={<BiCloudDownload size="22" />}
      />
    </Tooltip>
  );
};
